var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-summit-step-layout"},[_c('div',{staticClass:"q-summit-step-layout__header"},[_vm._t("header")],2),_c('div',{staticClass:"q-summit-step-layout__content"},[_vm._t("default")],2),_c('div',{staticClass:"q-summit-step-layout__footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }